<template>
  <div class="vx-row" id="rm-order-details-view" >
    <div class="vx-col w-full">
      <vx-card  v-if="dataLoaded" :title="orderDetails.order_code">
        <template slot="actions">
          <div class="flex">
            <div class="flex">
              <vs-button  @click="onClickPoPdf()" class="ml-2" color="dark" type="border" >Purchase Order PDF</vs-button>
              <vx-tooltip class="ml-2" text="View Sent PDF Log" position="top">
                <vs-button @click.stop="viewSendEmailLog()"
                           color="primary" type="border" icon-pack="feather" icon="icon-book"></vs-button>
              </vx-tooltip>
              <vs-button  @click="navigateBack()" class="ml-2" color="success" type="border" icon-pack="feather" icon="icon-arrow-left">Back to Orders</vs-button>
            </div>
          </div>
        </template>
        <div class="vx-row md:mb-3 mt-8">
          <div class="vx-col md:w-1/3 w-full">
            <vs-row vs-type="flex">
              <vs-col
                vs-type="flex" vs-justify="center" vs-align="start" vs-w="2">
                <feather-icon icon="UserIcon" class="text-success cursor-pointer"/>
              </vs-col>
              <vs-col
                vs-type="flex" vs-justify="start" vs-align="start" vs-w="10">
                  <span class="text-md">
                    <h5 class="mb-2">Address</h5>
                    {{orderDetails.line1 ? `${orderDetails.line1}, ` : ''}}
                    {{orderDetails.line2 ? orderDetails.line2+', ' : ''}}
                    {{orderDetails.line3 ? orderDetails.line3+', ' : ''}}
                    {{orderDetails.town_state ? orderDetails.town_state+', ' : ''}}
                    {{orderDetails.post_code ? orderDetails.post_code+', ' : ''}}
                    {{orderDetails.country ? orderDetails.country+', ' : ''}}
                  </span>
              </vs-col>
            </vs-row>
          </div>
          <div class="vx-col md:w-1/3 w-full">
            <vs-row vs-type="flex">
              <vs-col
                vs-type="flex" vs-justify="center" vs-align="start" vs-w="2">
                <feather-icon icon="TruckIcon" class="text-success cursor-pointer"/>
              </vs-col>
              <vs-col
                vs-type="flex" vs-justify="start" vs-align="start" vs-w="10">
                  <span class="text-md">
                    <h5 class="mb-2">Special Delivery Instruction</h5>
                    {{orderDetails.delivery_instruction ? orderDetails.delivery_instruction : 'N/A'}}
                  </span>
              </vs-col>
            </vs-row>
          </div>
          <div class="vx-col md:w-1/3 w-full">
            <vs-row vs-type="flex">
              <vs-col
                vs-type="flex" vs-justify="center" vs-align="start" vs-w="2">
                <feather-icon icon="InfoIcon" class="text-success cursor-pointer"/>
              </vs-col>
              <vs-col
                vs-type="flex" vs-justify="start" vs-align="start" vs-w="10">
                  <span class="text-md">
                    <h5 class="mb-2">Note</h5>
                    {{orderDetails.note ? orderDetails.note : 'N/A'}}
                  </span>
              </vs-col>
            </vs-row>
          </div>
        </div>
        <div class="vx-row md:mb-3 mt-8">
          <!-- <div class="vx-col md:w-1/3 w-full">
            <vs-row vs-type="flex">
              <vs-col
                vs-type="flex" vs-justify="center" vs-align="start" vs-w="2">
                <feather-icon icon="CreditCardIcon" class="text-success cursor-pointer"/>
              </vs-col>
              <vs-col
                vs-type="flex" vs-justify="start" vs-align="start" vs-w="10">
                  <span class="text-md break-all">
                    <h5 class="mb-2">Payment Status</h5>
                    <v-select :clearable="false"
                              :options="payment_status"
                              v-model="orderDetails.payment_status"
                              @input="openPaymentStatusChangeConfirm()"
                              :reduce = "option => option.value"
                              label="name"
                              :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    />
                  </span>
              </vs-col>
            </vs-row>
          </div> -->
          <div class="vx-col md:w-1/3 w-full">
            <vs-row vs-type="flex">
              <vs-col
                vs-type="flex" vs-justify="center" vs-align="start" vs-w="2">
                <feather-icon icon="CalendarIcon" class="text-success cursor-pointer"/>
              </vs-col>
              <vs-col
                vs-type="flex" vs-justify="start" vs-align="start" vs-w="10">
                  <span class="text-md break-all">
                    <h5 class="mb-2">Required By Date</h5>
                    {{orderDetails.required_by ? orderDetails.required_by : 'N/A'}}
                  </span>
              </vs-col>
            </vs-row>
          </div>
          <div class="vx-col md:w-1/3 w-full">
            <vs-row vs-type="flex">
              <vs-col
                vs-type="flex" vs-justify="center" vs-align="start" vs-w="2">
                <feather-icon icon="UserCheckIcon" class="text-success cursor-pointer"/>
              </vs-col>
              <vs-col
                vs-type="flex" vs-justify="start" vs-align="start" vs-w="10">
                  <span class="text-md break-all">
                    <h5 class="mb-2">Status</h5>
                    <div class="flex items-center justify-between con-btns-user">
                        <div class="flex items-center justify-start con-userx">
                          {{ orderDetails.status.name }}
                        </div>
                    </div>
                    <div class="flex mb-4 mt-2">
                          <vs-button v-if="['Submitted'].includes(orderDetails.status.name)" @click="onClickStatusChangeConfirm(orderDetails.id, 'accept')" type="border" size="small" icon-pack="feather" icon="icon-log-in" color="warning" class="mr-2">Accept Order</vs-button>
                          <vs-button v-if="['Accepted'].includes(orderDetails.status.name)" @click="onClickStatusChangeConfirm(orderDetails.id, 'receive')"  type="border" size="small" icon-pack="feather" icon="icon-box" color="success" class="mr-2">Receive Order</vs-button>
                          <vs-button v-if="['Received'].includes(orderDetails.status.name)" @click="onClickStatusChangeConfirm(orderDetails.id, 'return')" type="border" size="small" icon-pack="feather" icon="icon-x" color="danger" class="mr-2">Return Order</vs-button>
                          <vs-button v-if="['Received'].includes(orderDetails.status.name)" @click="onClickStatusChangeConfirm(orderDetails.id, 'complete')" type="border" size="small" icon-pack="feather" icon="icon-check" color="primary" class="mr-2">Complete Order</vs-button>
                    </div>
                  </span>
              </vs-col>
            </vs-row>
          </div>
        </div>
      </vx-card>
      <vx-card v-if="dataLoaded" class="mt-8" title="Order Items">
        <div class="vx-row my-8">
          <div class="vx-col w-full">
            <div class="vx-row mb-4">
              <div class="w-full vx-col md:w-2/3 md:mb-0">
                <h4 class="my-2">Order service items</h4>
                <vs-table :data="orderDetails.order_items">

                  <template slot="thead">
                    <vs-th>Service</vs-th>
                    <vs-th>Service Description</vs-th>
                    <vs-th>Payment Status</vs-th>
                    <vs-th>Unit price Excl vat/tax in GBP</vs-th>
                    <vs-th>VAT in GBP</vs-th>
                    <vs-th>Quantity</vs-th>
                  </template>

                  <template slot-scope="{data}">
                    <vs-tr :key="index_item" v-for="(tr_item, index_item) in data">

                      <vs-td :data="tr_item.other_supplier_service_name">
                        {{ tr_item.other_supplier_service_name }}
                      </vs-td>

                      <vs-td :data="tr_item.description">
                        {{ tr_item.description || 'N/A' }}
                      </vs-td>

                      <vs-td :data="tr_item.payment_status">
                        {{ tr_item.payment_status }}
                      </vs-td>

                      <vs-td :data="tr_item.unit_price">
                        {{ tr_item.unit_price }}
                      </vs-td>

                      <vs-td :data="tr_item.vat">
                        {{ tr_item.vat || 'N/A'}}
                      </vs-td>

                      <vs-td :data="tr_item.quantity">
                        {{ tr_item.quantity }}
                      </vs-td>

                    </vs-tr>
                  </template>

                </vs-table>
              </div>
            </div>
            <div class="vx-row mb-4">
              <div class="w-full vx-col md:w-2/3 md:mb-0">
                <h4 class="my-2">Additional cost</h4>
                <vs-table :data="orderDetails.additional_cost">

                  <template slot="thead">
                    <vs-th width="60%">Name</vs-th>
                    <vs-th width="20%">Amount Excl vat/tax in GBP</vs-th>
                    <vs-th width="20%">VAT in GBP</vs-th>
                  </template>

                  <template slot-scope="{data}">
                    <vs-tr :key="index_item" v-for="(tr_item, index_item) in data">

                      <vs-td :data="tr_item.name">
                        {{ tr_item.name }}
                      </vs-td>

                      <vs-td :data="tr_item.amount">
                        {{ tr_item.amount }}
                      </vs-td>

                      <vs-td :data="tr_item.vat">
                        {{ tr_item.vat || 'N/A'}}
                      </vs-td>

                    </vs-tr>
                  </template>
                </vs-table>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
    <other-item-purchase-order-pdf-pop-up ref="otherItemPurchaseOrderPdfPopUp"/>
    <other-service-order-invoice-email-log-pop-up ref="otherServiceOrderInvoiceEmailLogPopUp"/>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'

const OtherSupplierRepository = RepositoryFactory.get('other_supplier')
import OtherItemPurchaseOrderPdfPopUp
  from "@/components/popups/other-suppliers/orders/documents/OtherItemPurchaseOrderPdfPopUp";
import OtherServiceOrderInvoiceEmailLogPopUp
  from "@/components/popups/other-suppliers/orders/OtherServiceOrderInvoiceEmailLogPopUp";

export default {
  name: "OtherSupplierOrderView",
  components:{
    'v-select': vSelect,
    OtherItemPurchaseOrderPdfPopUp,
    OtherServiceOrderInvoiceEmailLogPopUp,
  },
  data () {
    return {
      id:'',
      orderDetails:{},
      payment_status:[
        {name: 'Pre Invoice', value: 'pre-invoice'},
        {name: 'Paid', value: 'paid'},
        {name: 'GRNI', value: 'grni'}
      ],
      dataLoaded:false
    }
  },
  mixins : [ SuccessMessage, ErrorMessages],
  async mounted() {
    this.id = this.$route.params.id
    await this.getSupplierOrderDetails()
  },
  methods:{
    async getSupplierOrderDetails(){
      await this.$vs.loading()
      try {
        const {data} = await OtherSupplierRepository.getSupplierServiceOrder(this.id)
        this.orderDetails = data.data
        this.dataLoaded = true
      }catch (error){
        this.convertAndNotifyError(error)
      }
      this.$vs.loading.close()
    },
    openPaymentStatusChangeConfirm(){
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm',
        text: 'Are you sure you want to change payment status?',
        accept: this.onClickChangePaymentStatus,
      })
    },
    async onClickChangePaymentStatus(){
      await this.$vs.loading()
      try {
        const status = this.orderDetails.payment_status
        await OtherSupplierRepository.statusChangeSupplierServicesOrder(this.orderDetails.id, status)
        await this.getSupplierOrderDetails()
        this.showSuccessMessage('Status change successfully!')
      }catch (error){
        this.convertAndNotifyError(error)
      }
      this.$vs.loading.close()
    },
    onClickStatusChangeConfirm(id, status) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: 'Confirm',
        text: 'Are you sure you want to make this change?',
        accept: this.onChangeSampleOrderStatus,
        parameters: [id, status]
      })
    },
    async onChangeSampleOrderStatus(params){
      await this.$vs.loading()
      try {
        await OtherSupplierRepository.statusChangeSupplierServicesOrder(params[0], params[1])
        this.showSuccessMessage('Status change successfully!')
        await this.getSupplierOrderDetails()
      }catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close()
    },
    async onClickPoPdf() {
      let routeData = this.$router.resolve({name:'other-supplier-service-order-print-view', params:{id:this.id}})
      window.open(routeData.href,'_blank');
    },
    navigateBack(){
      this.$router.push({path: `/pages/other-supplier-service?step=2`})
    },
    async viewSendEmailLog() {
      await this.$refs.otherServiceOrderInvoiceEmailLogPopUp.openPopUp(this.id)
    }
  }
}
</script>

<style scoped>

</style>
